export default "__VITE_ASSET__Ce8IT90d__"